import moment from 'moment'
import React from 'react'
import {PDFDownloadLink, Document, Page, Text, View } from '@react-pdf/renderer'
import {Header, Title} from './common'
import PlanInfo from './plan-info'
import Standards from './standards'
import Field from './field'
import styles from './styles'

export default function DownloadLink ({document, fileName, className, children}) {
  return (
    <PDFDownloadLink className={className} fileName={fileName} document={document}>
      {children}
    </PDFDownloadLink>
  )
}

function Plan (plan) {
  return (
    <View style={[styles.content, styles.plan]}> 
      <PlanInfo {...plan} />
      {plan.groupedStandards.length > 0 && (<Standards {...plan} />)}
      {plan.items.length > 0 && plan.items.map(field => (
        <Field
          key={field.id}
          className={field.name}
          name={field.content.name}
          context={plan}
          sections={field.content.sections}
        />
      ))}
    </View>
  )
}

function Group ({plans, index}) {
  return (
    <View style={[styles.group, styles[`group${index}`]]}>
      {plans.length > 0 && plans.map(plan => <Plan key={plan.id} {...plan}/>)}
    </View>
  )
}

export function PDFDocument ({groupMap, author, range, title}) {
  return (
    <Document style={styles.document}>
      <Page size="A4" style={styles.page} wrap>
        <Header>
          <Text style={styles.headerTitle}>{title}</Text>
          <Text style={styles.groupRange}>{range}</Text>
        </Header>
        <View style={styles.groups}>
          {Object.entries(groupMap).map(([key, plans], index) => <Group key={key} {...{plans, index}} />)}
        </View>
        <Text style={[styles.author, styles.footer]} fixed>
          {author.name} {author.lastName}
        </Text>
        <Text style={[styles.paging, styles.footer]} fixed render={ props => {
          const {pageNumber, totalPages} = props
          return totalPages ? `${pageNumber} / ${totalPages}` : `${pageNumber}`
        }} />
      </Page>
    </Document>
  )
}

